




















































import { defineComponent } from '@vue/composition-api';

import CommonProvinceSelector from '@/components/LocationAddress/CommonProvinceSelector.vue';
import CommonDistrictSelector from '@/components/LocationAddress/CommonDistrictSelector.vue';
import CommonSubdistrictSelector from '@/components/LocationAddress/CommonSubdistrictSelector.vue';

const GroupAddressEditor = defineComponent({
  setup(props: any, context: any) {
    function onUpdate(type: string, newValue: any) {
      if (type === 'province') {
        context.emit('input', {
          ...props.value,
          province: newValue,
          district: { id: '' },
          subdistrict: { id: '' },
        });
      } else if (type === 'district') {
        context.emit('input', {
          ...props.value,
          district: newValue,
          subdistrict: { id: '' },
        });
      } else if (type === 'subdistrict') {
        context.emit('input', {
          ...props.value,
          subdistrict: newValue,
          zipcode: newValue.zip_code,
        });
      } else if (type === 'postcode') {
        context.emit('input', {
          ...props.value,
          zipcode: newValue,
        });
      } else if (type === 'address') {
        context.emit('input', {
          ...props.value,
          address: newValue,
        });
      } else {
        context.emit('input', {
          province: null,
          subdistrict: null,
          district: null,
          address: '',
          zipcode: '',
        });
      }
    }

    return {
      onUpdate,
    };
  },
  props: {
    value: {}, // address object
    level: {},
    label: { default: 'ที่อยู่' },
    showLabel: { default: true },
    margin: { default: true },
    requiredAddress: { default: false },
    requiredProvince: { default: false },
    requiredDistrict: { default: false },
    requiredSubdistrict: { default: false },
    requiredPostcode: { default: false },
    emitAsString: { default: false },
    showAsEnglish: { default: false },
  },
  components: {
    CommonProvinceSelector,
    CommonDistrictSelector,
    CommonSubdistrictSelector,
  },
});

export default GroupAddressEditor;
